import { render, staticRenderFns } from "./LotteryReservationRegistration.vue?vue&type=template&id=1b6ffc1e&scoped=true&"
import script from "./LotteryReservationRegistration.vue?vue&type=script&lang=js&"
export * from "./LotteryReservationRegistration.vue?vue&type=script&lang=js&"
import style0 from "./LotteryReservationRegistration.vue?vue&type=style&index=0&id=1b6ffc1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ffc1e",
  null
  
)

export default component.exports